<template>
  <div class="file-picker-container">
    <div class="title">{{ title }}</div>
    <file-pond
      name="file"
      ref="pond"
      :label-idle="$t('attachment.placeholder')"
      v-bind:allow-multiple="multiple"
      accepted-file-types="image/jpeg, image/png, application/pdf"
      :server="{ url: baseURL + '/media/upload', headers: uploadHeaders }"
      v-bind:files="files"
      :credits="{}"
      :labelFileProcessing="$t('attachment.uploading')"
      :labelFileProcessingComplete="$t('attachment.uploaded')"
      :labelTapToCancel="$t('attachment.cancel')"
      :labelTapToUndo="$t('attachment.undo')"
      @processfile="handleFileUploadSuccess"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import axios from "axios";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default defineComponent({
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: true,
    },
    title: {
      required: false,
      type: String,
      default: null,
    },
  },
  components: {
    FilePond,
  },
  data: () => ({
    baseURL: null,
    files: [],
    media_ids: [],
  }),
  watch: {
    media_ids: {
      deep: true,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
  },
  beforeMount() {
    this.baseURL = axios.defaults.baseURL;
  },
  methods: {
    handleFileUploadSuccess(ev, fileItem) {
      const resp = JSON.parse(fileItem.serverId);
      this.media_ids.push(resp.id);
    },
    handleFileUploadDelete(deleteItem) {
      this.$refs.uploader.fileList.splice(
        this.$refs.uploader.fileList.indexOf(deleteItem),
        1
      );
      this.media_ids.splice(this.media_ids.indexOf(deleteItem.id), 1);
      this.$nextTick(() => {
        this.$refs.uploader.$emit(
          "on-change",
          deleteItem,
          this.$refs.uploader.fileList
        );
        this.$refs.uploader.$refs.previewer.close();
      });
    },
  },
  computed: {
    uploadHeaders() {
      return {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: this.$store.getters.isAuthenticated
          ? "Bearer " + this.$store.getters.getUser.token
          : null,
      };
    },
  },
});
</script>

<style lang="scss">
.vux-uploader_bd {
  display: flex;
  .vux-uploader_files {
    padding: 0;
  }
}
.filepond--drop-label {
  cursor: pointer;
}
.filepond--drop-label:hover {
  border: 2px solid;
  border-radius: 7px;
  border-style: dashed;
  background: #dfdedc;
}
.file-picker-container {
  border-bottom: 1px solid #eeeeee;
  .title {
    padding: 12px 12px 2px 12px;
  }
}
</style>
